import { useEffect, useState } from 'react'
import type { EmployeeGoldFactMonthRow } from '../types/employeeAnalysis'

export function useEmployeeGoldFact(userId: number | null) {
  const [data, setData] = useState<EmployeeGoldFactMonthRow[]>([])
  const [loading, setLoading] = useState(Boolean(userId))
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!userId) {
      setData([])
      setLoading(false)
      setError(null)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    fetch(
      `/ts_user_jsons/gold_fact_user_monthly_with_projects_user_id_${userId}.json`,
    )
      .then((r) => {
        if (!r.ok) throw new Error(`Failed to load user data: ${r.status}`)
        return r.json()
      })
      .then((json: EmployeeGoldFactMonthRow[]) => {
        if (!cancelled) setData(Array.isArray(json) ? json : [])
      })
      .catch((e: Error) => {
        if (!cancelled) {
          setError(e.message)
          setData([])
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [userId])

  return { data, loading, error }
}
